const rawBase = process.env.VUE_APP_API_BASE ?? "http://localhost:5003";
// En local, usar siempre 5003 si el .env apunta a 5002 (backend suele correr en 5003)
const base =
  typeof rawBase === "string" && rawBase.includes("localhost:5002")
    ? rawBase.replace("localhost:5002", "localhost:5003")
    : rawBase;
const isLocalHttps =
  base.startsWith("https://localhost") ||
  base.startsWith("https://127.0.0.1");
const API_BASE = (isLocalHttps ? base.replace(/^https:\/\//, "http://") : base).replace(/\/+$/, "");

export default API_BASE;